import { Component, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { DialogBase } from '@app/dialog/dialog-base';

@Component({
	selector: 'g-terms-dialog',
	templateUrl: './terms-dialog.component.html',
	styleUrls: ['./terms-dialog.component.scss'],
	standalone: false,
})
export class TermsDialogComponent extends DialogBase {
	protected store: Store<RootReducer.State>;

	static MAX_WIDTH = '800px';
	constructor() {
		const store = inject<Store<RootReducer.State>>(Store);

		super(store);

		this.store = store;
	}
}
